// extracted by mini-css-extract-plugin
module.exports = {"comentariIntroduccioSelectorImatgeContenidorImatgeAfegir":"IntroduccioIndividuFenofasesComentari_comentariIntroduccioSelectorImatgeContenidorImatgeAfegir__2NYkR"};